import baseComponent from 'BASE/components/chat/chat.base.component.room'
import { actionTypes } from 'BASE/store/types'

export default {
    mixins: [baseComponent],
    methods: {
        closeRoomWindow(){
            this.$store.dispatch(actionTypes.CHAT_CLOSE_ROOM_WINDOW, {
                roomId: this.prop_room.id,
                onTalkTime: undefined
            });
        },
        async removeGroupRoom() {
            let result = await this.$dialog.confirm(`确认要删除 [${this.prop_room.name}] 群组吗?`);
            if (result.state) {
                let errorMessage = await this.$store.dispatch(actionTypes.CHAT_REMOVE_GROUP_ROOM, { 
                    roomId: this.prop_room.id,
                });
                if (errorMessage) {
                    this.$dialog.warning("删除群组失败，" + errorMessage);
                }
            }
        },
        setGroupRoomName() {
            if (!this.isGroupRoomAdmin) {
                return;
            }
            this.$dialog.get("setGroupRoomName").show({ 
                roomId: this.prop_room.id,
            });
        },
        openJoinGroupRoomDialog() {
            let loginId = this.$store.state.chat.roomMemberContainers
                .find((item) => item.room.id === this.prop_room.id).roomMembers
                .find((item) => item.userId !== this.$store.state.chat.userId).loginId;

            this.$dialog.get("joinGroupRoom").show({ 
                loginId: loginId,
            });
        }
    },
};
